import RecruitingCard from "../../components/SuggestCards/RecrutingCard";
import GroupedCampaignTab from "./GroupedCampaignTab";

export default function ContractedTab({ list, lastItemRef, loading, onChanged }) {
  return (
    <GroupedCampaignTab
      list={list}
      lastItemRef={lastItemRef}
      renderItem={(item) => <RecruitingCard item={item} onChanged={onChanged} />}
      loading={loading}
    />
  );
}
